import api from './api';

const getSiteToken = () => localStorage.getItem('site_token');

const sitesApi = {
    setToken(token) {
        if (token) {
            localStorage.setItem('site_token', token);
        } else {
            localStorage.removeItem('site_token');
        }
    },
    
    _getConfig(config = {}) {
        const token = getSiteToken();
        const headers = { ...config.headers };
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        return { ...config, headers };
    },

    get(url, config) {
        return api.get(url, this._getConfig(config));
    },

    post(url, data, config) {
        return api.post(url, data, this._getConfig(config));
    },

    put(url, data, config) {
        return api.put(url, data, this._getConfig(config));
    },

    delete(url, config) {
        return api.delete(url, this._getConfig(config));
    },
    
    // Auth
    login: (data) => sitesApi.post('/api/sites/auth/login', data),
    register: (data) => sitesApi.post('/api/sites/auth/register', data),
    getProfile: () => sitesApi.get('/api/sites/auth/profile'),
    
    // Sites
    getSites: () => sitesApi.get('/api/sites'),
    createSite: (data) => sitesApi.post('/api/sites', data),
    getSite: (id) => sitesApi.get(`/api/sites/${id}`),
    updateSite: (id, data) => sitesApi.put(`/api/sites/${id}`, data),
    publishSite: (id, data) => sitesApi.post(`/api/sites/${id}/publish`, data),
    unpublishSite: (id) => sitesApi.post(`/api/sites/${id}/unpublish`),
    deleteSite: (id) => sitesApi.delete(`/api/sites/${id}`),
    updateSettings: (id, data) => sitesApi.put(`/api/sites/${id}/settings`, data),
    
    // Templates
    getTemplates: () => sitesApi.get('/api/sites/templates/all'),
    getTemplate: (id) => sitesApi.get(`/api/sites/templates/${id}`),
    
    // Subscription
    getPlans: () => sitesApi.get('/api/sites/subscription/plans'),
    subscribe: (data) => sitesApi.post('/api/sites/subscription/subscribe', data),
    getSubscriptionDetails: () => sitesApi.get('/api/sites/subscription/details'),
    
    // Analytics
    getAnalytics: (id, params) => sitesApi.get(`/api/sites/${id}/analytics`, { params })
};

export default sitesApi;
